// localStorage counterpart to session-storage.utils.ts — same rationale, see
// createSafeStorage in safe-storage.utils.ts.
import { createSafeStorage } from './safe-storage.utils'

const local = createSafeStorage(() => localStorage)

export const safeReadLocal = local.read
export const safeWriteLocal = local.write
export const safeRemoveLocal = local.remove
